import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  [key: string]: any;
  isSignedIn: boolean;
};
const initialState: State = { isSignedIn: false };

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signIn: (state, payload: PayloadAction<[string, any][]>) => {
      state.isSignedIn = true;
      payload.payload.forEach((p) => {
        const k = p[0];
        const v = p[1];
        state[k] = v;
      });
    },
    signOut: (state) => {
      return { isSignedIn: false };
    }
  },
})

// Action creators are generated for each case reducer function
export const { signIn, signOut } = authSlice.actions;
export default authSlice.reducer;